import type { Ref } from 'vue'
import type { TSportEvent } from 'markets-store'
import { useHomeStore } from '../../stores/useHomeStore'
import { getTopEvents } from './helpers/getTopEvents'

type MaybeRef<T> = Ref<T> | T

interface UseTopEventsParams {
  duplicateEventIds?: MaybeRef<number[]>
  timeFilterInMs?: MaybeRef<number | null>
  quantity?: MaybeRef<number>
}

export function useTopEvents({
  duplicateEventIds = [],
  timeFilterInMs = null,
  quantity = 30,
}: UseTopEventsParams = {}) {
  const { sbTopSportEvents, sbTopRules } = storeToRefs(useHomeStore())
  const sportEvents = useSportEvents()

  const topEventsFilter = computed(() => {
    const duplicateIds = new Set(unref(duplicateEventIds))

    const timeFilter = unref(timeFilterInMs)
    const scheduledBefore = timeFilter ? Date.now() + timeFilter : Infinity

    return (event: TSportEvent) =>
      event.scheduled < scheduledBefore && !duplicateIds.has(event.id)
  })

  const topEvents = computed<TSportEvent[]>(() => {
    if (!sbTopRules.value || !sbTopSportEvents.value) return []

    return getTopEvents({
      events: sportEvents.value,
      filter: topEventsFilter.value,
      quantity: unref(quantity),
      sbTopRules: sbTopRules.value,
      sbTopEvents: sbTopSportEvents.value,
    })
  })

  return { topEvents }
}
